import { useEffect, useState } from 'react';
import { LOCAL_STORAGE_KEYS } from 'constant';
import useApiServices from './useApiandServices';
import { useFormResultsStore } from '../store/useFormResultsStore';

const useStatesandActions = () => {
  const [perPage, setPerPage] = useState(
    Number.isNaN(Number(localStorage.getItem(LOCAL_STORAGE_KEYS.PER_PAGE)))
      ? 15
      : Number(localStorage.getItem(LOCAL_STORAGE_KEYS.PER_PAGE)),
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState(null);
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);

  const { filterQueryParams, setTotalFiltersToBeCleared } =
    useFormResultsStore();
  const { serverState, apiActions } = useApiServices();

  const calculateTotalFilters = () => {
    const excludedKeys = ['form_result', 'page', 'per_page', 'q', 'start_date'];
    const remainingFilters = Object.fromEntries(
      Object.entries(filterQueryParams).filter(
        ([key]) => !excludedKeys.includes(key),
      ),
    );
    const total = Object.values(remainingFilters).reduce(
      (acc: number, curr: unknown) => {
        if (Array.isArray(curr)) {
          return acc + (curr.length || 0);
        }
        if (curr) {
          return acc + 1;
        }
        return acc;
      },
      0,
    );
    setTotalFiltersToBeCleared(total);
  };
  useEffect(() => {
    calculateTotalFilters();
  }, [filterQueryParams]);

  const extendedState = {
    ...serverState,
    searchText,
    perPage,
    pageNumber,
    isExportDialogOpen,
  };
  const extendedAction = {
    setSearchText,
    setPerPage,
    setPageNumber,
    setIsExportDialogOpen,
  };

  const actions = {
    // Api actions
    ...apiActions,
    ...extendedAction,
  };

  return [extendedState, actions];
};

export default useStatesandActions;
